import { render, staticRenderFns } from "./OnlCgreportHeadModal.vue?vue&type=template&id=1e1d625e&"
import script from "./OnlCgreportHeadModal.vue?vue&type=script&lang=js&"
export * from "./OnlCgreportHeadModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports